// extracted by mini-css-extract-plugin
export default {"root":"fCKVq1","debugBorder":"DkRTzm"};